module.exports = __webpack_public_path__ + "img/Controller.6ba7e693.png";